import clsx from 'clsx';

import { useStyles } from './styles';

interface PrivatePageWrapperProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

export function PrivatePageWrapper({
  children,
  noPadding,
}: PrivatePageWrapperProps): JSX.Element {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, {
        [classes.noPadding]: noPadding,
      })}
    >
      {children}
    </div>
  );
}
